import { SceneGraphNode } from '../../models/scene-graph-node';
import { StrToStr, StrToBool } from './serialize-graph-types';
import { SerializeGraphUtils } from './serialize-graph-utils';


declare const Human: any;

/* Serialize the Scene Graph for Module File Export
*/

export function serializeGraph(namespaceMap: StrToStr, excludeMap: StrToBool, overwrite: boolean, replaceObjectId = false): SceneGraphNode[] {
  const rootObjects = Human.scene.rootObjects;

  const sceneGraph: SceneGraphNode[] = [];
  Object.entries(rootObjects).forEach(([id, rootObject]) => {
    const rootNode = SerializeGraphUtils.serializeHumanObject(rootObject, namespaceMap, overwrite, excludeMap, replaceObjectId);
    if (rootNode !== null) {
      sceneGraph.push(rootNode);
    }
  }, this);

  return sceneGraph;
}

